import React from 'react';

const Title = props => {
    return (
        <div
            style={{
                fontSize: props.fontSize,
                color: props.color,
                fontWeight: props.fontWeight,
                lineHeight: props.lineHeight ? props.lineHeight : props.fontSize,
                textTransform: 'uppercase',
                fontFamily: props.fontFamily,
                textAlign: 'center',
                width:(props.width?? '280px')
            }}>
            {props.children}
        </div>
    );
}

export default Title;
